import React, { useEffect } from "react";

// hooks
import useToggle from "../../../../../hooks/useToggle";

// components
import Handler from "../edge/Handler";

export default function MetaPreview({
  previewType = "default",
  node,
  color,
  isConnected,
  onEdgeMouseDown,
  checkIsEdgeConnected,
  allowToShowEdge = true,
  allowToEditFlow,
}) {
  const [isCopied, setIsCopied] = useToggle(false);

  useEffect(() => {
    if (isCopied) {
      const timeout = setTimeout(() => setIsCopied(false), 5000);

      return () => clearTimeout(timeout);
    }
  }, [isCopied]);

  return (
    <div className="relative w-full h-full px-2.5 py-5 bg-white rounded-xl">
      <div className="relative w-full max-w-64 flex flex-col   rounded-[10px]">
        <div className="w-full flex items-center bg-[#F8F9FC] ">
          <img
            src={node?.data?.ad_thumbnail}
            alt=""
            className="w-20 rounded-l-lg"
          />
          <span className="font14px-500 text-[var(--textBlack)] pl-10">
            {node?.data?.ad_title}
          </span>
        </div>
        <div className="text-[var(--font-600)] mt-10">
          <span className="font12px-400 ">
            Hi! Please let us know how we can help you.
          </span>
          {node?.data?.pop_messages?.map((pop) => {
            const connection_point = {
              id: pop?.id,
              type: "action",
            };
            let isConnected = false;
            if (checkIsEdgeConnected) {
              isConnected = checkIsEdgeConnected({
                start_node_id: node?.uniq_id,
                connection_point,
              });
            }

            return (
              <div className="font13px-500 border-b relative" key={pop?.id}>
                <div className="mt-10 mb-10">
                  <span>{pop?.button_text}</span>
                </div>
                <div className="absolute top-1 -right-1.5 z-10">
                  <Handler
                    type="start"
                    isConnected={isConnected}
                    onEdgeMouseDown={({ position, payload }) => {
                      if (onEdgeMouseDown && !isConnected) {
                        onEdgeMouseDown({
                          connection_point,
                          position: position,
                          payload,
                        });
                      }
                    }}
                    color="#0082FB"
                    allowToEditFlow={allowToEditFlow}
                  />
                </div>
              </div>
            );
          })}
          {/* <span className="text-end">Next Step</span> */}
        </div>
      </div>
    </div>
  );
}
